import {
  InMemoryHeader,
  InMemoryString
} from "pbas-vue-components";

import { translate } from '../trans'
import store from '@/store'
import { tokens } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";

const telephoneMask= "(###) ### - ####";
const InMemoryContactsPlanCreationHeaders = [
  new InMemoryHeader({
    title: "Identifier",
    type: new InMemoryString("Identifier"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    version: 1
  }),
  new InMemoryHeader({
    title: "headers.members_management.Title",
    type: new InMemoryString("Title/Name", {
      getString: item => {
        if (!item) return "";
        const lang = store.getters['common/language']
        return translate(item.Title, lang.language);
      }
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "globals.name",
    type: new InMemoryString("Name"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "headers.contacts.email",
    type: new InMemoryString("Email"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "headers.locals.phone_number",
    type: new InMemoryString("PhoneNumber", {
      getString: (item) => {
        if (item.PhoneNumber) {
          return masker(item.PhoneNumber, telephoneMask, true, tokens);
        }
        return "";
      }
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "globals.fax_number",
    type: new InMemoryString("Fax", {
      getString: (item) => {
        if (item.Fax) {
          return masker(item.Fax, telephoneMask, true, tokens);
        }
        return "";
      }
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "components.plancreationwizard.primary",
    type: new InMemoryString("IsPrincipal"),
    sortable: true,
    visible: true,
    searchable: true
  })
];
export default InMemoryContactsPlanCreationHeaders;